
import List from 'layouts/order/List.js';
import OrderDetails from 'layouts/order/OrderDetails.js';
import Pickup from 'layouts/order/Pickup.js';
import ProtectedRoute from './ProtectedRoute';

const OrderRoutes = [

    {
      route: "/order/list/:pageNo",
      key: "manage-orders",
      component: <ProtectedRoute check="logout"><List /></ProtectedRoute>
    },
    {
      route: "/order/details/:orderID",
      key: "order-details",
      component: <ProtectedRoute check="logout"><OrderDetails /></ProtectedRoute>
    },
    {
      route: "/order/pickup/:pageNo",
      key: "manage-pickup",
      component: <ProtectedRoute check="logout"><Pickup /></ProtectedRoute>
    },    

  ];

export default OrderRoutes;